import merge from 'lodash/merge';
import { StyleSheet } from 'react-native';
import { gridConfig, skeletonLoaderConfig, tokens } from '../../constants';
import { scale, scaledHeight } from '../../utils';
export var getSkeletonLoaderStyles = (props, breakpoints) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
  var config = props.config,
    theme = props.theme,
    color = props.color,
    type = props.type,
    fullWidth = props.fullWidth,
    _height = props.height,
    _width = props.width,
    _scaledHeight = props.scaledHeight,
    _scaledWidth = props.scaledWidth,
    showTopMargin = props.showTopMargin,
    showLeftMargin = props.showLeftMargin,
    showRightMargin = props.showRightMargin;
  var configProps = config === null || config === void 0 ? void 0 : config[type];
  var height = _height !== null && _height !== void 0 ? _height : _scaledHeight && _scaledWidth ? scaledHeight(_scaledWidth, _scaledHeight) : configProps === null || configProps === void 0 ? void 0 : configProps.height;
  var width = _width !== null && _width !== void 0 ? _width : _scaledWidth ? scale(_scaledWidth) : configProps === null || configProps === void 0 ? void 0 : configProps.width;
  var borderRadius = (_a = tokens.borderRadius) === null || _a === void 0 ? void 0 : _a[configProps === null || configProps === void 0 ? void 0 : configProps.borderRadius];
  var marginTop = (_d = (_c = (_b = gridConfig === null || gridConfig === void 0 ? void 0 : gridConfig[theme]) === null || _b === void 0 ? void 0 : _b.config) === null || _c === void 0 ? void 0 : _c[breakpoints]) === null || _d === void 0 ? void 0 : _d.rowSpacing;
  var marginLeft = (_g = (_f = (_e = gridConfig === null || gridConfig === void 0 ? void 0 : gridConfig[theme]) === null || _e === void 0 ? void 0 : _e.config) === null || _f === void 0 ? void 0 : _f[breakpoints]) === null || _g === void 0 ? void 0 : _g.columnSpacing;
  var marginRight = (_k = (_j = (_h = gridConfig === null || gridConfig === void 0 ? void 0 : gridConfig[theme]) === null || _h === void 0 ? void 0 : _h.config) === null || _j === void 0 ? void 0 : _j[breakpoints]) === null || _k === void 0 ? void 0 : _k.columnSpacing;
  return StyleSheet.create({
    container: {
      display: 'flex',
      flexDirection: 'row'
    },
    skeleton: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
      height,
      width,
      borderRadius,
      backgroundColor: color
    }, fullWidth && {
      flex: 1
    }), showTopMargin && {
      marginTop: (_l = tokens.spacing) === null || _l === void 0 ? void 0 : _l[marginTop]
    }), showLeftMargin && {
      marginLeft: (_m = tokens.spacing) === null || _m === void 0 ? void 0 : _m[marginLeft]
    }), showRightMargin && {
      marginRight: (_o = tokens.spacing) === null || _o === void 0 ? void 0 : _o[marginRight]
    }), {
      overflow: 'hidden'
    })
  });
};
export var getSkeletonLoaderProps = (props, context) => {
  var _a;
  var theme = (props === null || props === void 0 ? void 0 : props.theme) || (context === null || context === void 0 ? void 0 : context.theme);
  var configProps = merge(skeletonLoaderConfig === null || skeletonLoaderConfig === void 0 ? void 0 : skeletonLoaderConfig[theme], (_a = context === null || context === void 0 ? void 0 : context.skeletonLoader) === null || _a === void 0 ? void 0 : _a[theme]);
  var animationDuration = props.animationDuration;
  if (!animationDuration) {
    animationDuration = configProps.animationDuration;
  }
  return Object.assign(Object.assign(Object.assign({
    theme
  }, configProps), props), {
    animationDuration
  });
};